// Angular
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

//adal
import { Adal5Interceptor } from './services/adal/adal5-interceptor';
import { Adal5User } from './services/adal/adal5-user';
import { Adal5Service } from './services/adal/adal5.service';
import { Adal5HTTPService } from './services/adal/adal5-http.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
export * from './services/adal/adal5-user';
export * from './services/adal/adal5.service';
export * from './services/adal/adal5-http.service';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// 3rd party
import { Ng2Webstorage } from 'ngx-webstorage';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// Helper components
import { WidgetRegistrationComponent } from './components/layout/widget-registration/widget-registration.component';
import { DataErrorDisplayComponent } from './components/data-error-display/data-error-display.component';
import { GroupKeyVisibleFilterPipe } from './directives/GroupKeyVisibleFilterPipe';

// Diff finder service used by platform config
import { ObjectDiffFinderService } from './services/ObjectDiffFinderService';

// Core container component
import { CoreWidgetContainerComponent } from './components/layout/core-widget-container/core-widget-container.component';

// Admin component widgets
import { CacheDataAdminComponent } from './components/widgets/admin/cache-data-admin/cache-data-admin.component';
import { DiagnosticsComponent } from './components/widgets/admin/diagnostics/diagnostics.component';
import { DataPolicyTestingComponent } from './components/widgets/admin/data-policy-testing/data-policy-testing.component';

// Configuration editor components
import { CacheRuleEditorComponent } from './components/widgets/admin/Editors/cache-rule-editor/cache-rule-editor.component';
import { CacheRulesEditorComponent } from './components/widgets/admin/Editors/cache-rules-editor/cache-rules-editor.component';
import {
  DataConsumerConfigEditorComponent
} from './components/widgets/admin/Editors/data-consumer-config-editor/data-consumer-config-editor.component';
import { DataGroupingEditorComponent } from './components/widgets/admin/Editors/data-grouping-editor/data-grouping-editor.component';
import { DataPolicyEditorComponent } from './components/widgets/admin/Editors/data-policy-editor/data-policy-editor.component';
import { FilterRuleEditorComponent } from './components/widgets/admin/Editors/filter-rule-editor/filter-rule-editor.component';
import { GenericChartConfigComponent } from './components/widgets/admin/Editors/generic-chart-config/generic-chart-config.component';
import { GenericTableConfigComponent } from './components/widgets/admin/Editors/generic-table-config/generic-table-config.component';
import { NameValueEditorComponent } from './components/widgets/admin/Editors/name-value-editor/name-value-editor.component';
import { WidgetConfigEditorComponent } from './components/widgets/admin/Editors/widget-config-editor/widget-config-editor.component';

import { MasterConfigurationComponent } from './components/widgets/admin/master-configuration/master-configuration.component';
import { UserWidgetPreferencesComponent } from './components/widgets/admin/user-widget-preferences/user-widget-preferences.component';

import { ServerHitLogsComponent } from './components/widgets/admin/server-hit-logs/server-hit-logs.component';
import { LandingPageComponent } from './components/widgets/landing-page/landing-page.component';
import { WidgetHelpComponent } from './components/widgets/admin/widget-help/widget-help.component';

import { GenericBaseComponent } from './components/widgets/generic/generic-base/generic-base.component';
export * from './components/widgets/generic/generic-base/generic-base.component';
import { GenericChartComponent } from './components/widgets/generic/generic-chart/generic-chart.component';
export * from './components/widgets/generic/generic-base/generic-base.component';

import { PlatformTableComponent } from './components/platform-table/platform-table.component';
import { PlatformTableXComponent } from './components/platform-table-x/platform-table-x.component';
export * from './components/platform-table/platform-table.component';
export * from './components/platform-table-x/platform-table-x.component';

// platform-multiselect 
import { AutofocusDirective } from './components/platform-multiselect/dropdown/autofocus.directive';
import { MultiselectDropdown } from './components/platform-multiselect/dropdown/dropdown.component';
import { MultiSelectSearchFilter } from './components/platform-multiselect/dropdown/search-filter.pipe';
export * from './components/platform-multiselect';

/**
 * Direcives
 */
import { BaseChartDirective } from './directives/chart/base-chart-directive';
export * from './directives/chart/base-chart-directive';
import { PlatformRouterLink, PlatformRouterLinkWithHref } from './directives/platform-router-link';



import {
  GenericGroupedDataSideNavComponent
} from './components/widgets/generic/generic-grouped-data-side-nav/generic-grouped-data-side-nav.component';
export * from './components/widgets/generic/generic-base/generic-base.component';
import { GenericTableComponent } from './components/widgets/generic/generic-table/generic-table.component';
export * from './components/widgets/generic/generic-base/generic-base.component';
import { LotForecasterComponent } from './components/widgets/lot-forecaster/lot-forecaster.component';
import { NetworkDiagramComponent } from './components/widgets/network-diagram/network-diagram.component';
import { RandomChartComponent } from './components/widgets/random-chart/random-chart.component';
import { RecursivePanelComponent } from './components/widgets/recursive-panel/recursive-panel.component';
export * from './components/widgets/generic/generic-base/generic-base.component';
import { TableauComponent } from './components/widgets/tableau/tableau.component';
export * from './components/widgets/tableau/tableau.component';
import { CanvasChartComponent } from './components/canvas-chart/canvas-chart.component';
export * from './components/canvas-chart/canvas-chart.component';
import { HighchartPlatformComponent } from './components/highchart-platform/highchart-platform.component';
export * from './components/highchart-platform/highchart-platform.component';

// Layout components
export * from './main.component';
export * from './components/layout/main-display/main-display.component';
export * from './components/layout/top-nav/top-nav.component';
export * from './components/layout/group-display/group-display.component';
export * from './components/layout/side-nav/side-nav.component';


// Base component widgets
export * from './components/widgets/BaseWidget/BaseWidget.component';
export * from './components/widgets/BaseManagedDataWidget/BaseManagedDataWidget.component';

// services
export * from './services/secret.service';
export * from './services/WebPlatformApiService';
export * from './services/DisplayStateService';
export * from './services/ClientSettingsService';
export * from './services/ObjectDiffFinderService';
export * from './services/AppStateService';
export * from './components/highchart-platform/highchart-platform-data-adapter';
export * from './components/highchart-platform/highchart-platform-interfaces';
export * from './components/highchart-platform/highchart-platform-models';

export * from './classes/UtilityFunctions';
export * from './classes/TreeMapDataSetAdapter';


export * from './classes/DataSetFilter';
export * from './classes/Descriptive';
export * from './classes/DataSetConverter';
export { Guid } from './classes/Guid';

export * from './interfaces/DisplayInterfaces';
export * from './interfaces/UserInterfaces';
export * from './interfaces/WidgetInterfaces';


import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';

export function highchartsModules() {
  // apply Highcharts Modules to this array
  // convert to requires for consistent method of importing between compiled and linked modes
  const highchartsMore = require('highcharts/highcharts-more');
  const exporting = require('highcharts/modules/exporting');
  const heatmap = require('highcharts/modules/heatmap');
  const treemap = require('highcharts/modules/treemap');
  const boost = require('highcharts/modules/boost');
  const ms = require('highcharts-multicolor-series/js/multicolor_series');
  return [exporting, heatmap, treemap, highchartsMore, boost, ms];
}

@NgModule({ // WebPlatformCoreModule
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    Ng2Webstorage,
    RouterModule,
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    ToastModule.forRoot(),
    TooltipModule.forRoot(),
    ChartModule,
  ],
  declarations: [
    // Admin components
    MasterConfigurationComponent, WidgetHelpComponent, CacheDataAdminComponent, UserWidgetPreferencesComponent,
    DiagnosticsComponent, ServerHitLogsComponent, LandingPageComponent,

    // Admin editor child components
    DataPolicyEditorComponent, CacheRuleEditorComponent, CacheRulesEditorComponent, DataConsumerConfigEditorComponent,
    DataGroupingEditorComponent, FilterRuleEditorComponent, GenericChartConfigComponent, GenericTableConfigComponent,
    NameValueEditorComponent, WidgetConfigEditorComponent,

    // Core container component
    CoreWidgetContainerComponent,

    // Misc components
    DataPolicyTestingComponent,
    LotForecasterComponent,
    NetworkDiagramComponent,
    RandomChartComponent,
    RecursivePanelComponent,
    TableauComponent,
    WidgetRegistrationComponent,
    GroupKeyVisibleFilterPipe,
    DataErrorDisplayComponent,
    HighchartPlatformComponent,
    CanvasChartComponent,

    // Generic widgets
    GenericBaseComponent, GenericChartComponent, GenericTableComponent,
    GenericGroupedDataSideNavComponent, PlatformTableComponent, PlatformTableXComponent,
    BaseChartDirective,
    MultiselectDropdown,
    MultiSelectSearchFilter,
    AutofocusDirective,

    PlatformRouterLink, PlatformRouterLinkWithHref
  ],
  exports: [
    // Admin components
    MasterConfigurationComponent, WidgetHelpComponent, CacheDataAdminComponent, UserWidgetPreferencesComponent,
    DiagnosticsComponent, ServerHitLogsComponent, LandingPageComponent,

    // Admin editor child components
    DataPolicyEditorComponent, CacheRuleEditorComponent, CacheRulesEditorComponent, DataConsumerConfigEditorComponent,
    DataGroupingEditorComponent, FilterRuleEditorComponent, GenericChartConfigComponent, GenericTableConfigComponent,
    NameValueEditorComponent, WidgetConfigEditorComponent,

    // Core container component
    CoreWidgetContainerComponent,

    // Misc components
    DataPolicyTestingComponent,
    LotForecasterComponent,
    NetworkDiagramComponent,
    RandomChartComponent,
    RecursivePanelComponent,
    TableauComponent,
    WidgetRegistrationComponent,
    GroupKeyVisibleFilterPipe,
    DataErrorDisplayComponent,
    HighchartPlatformComponent,
    CanvasChartComponent,

    // Generic widgets
    GenericBaseComponent, GenericChartComponent, GenericTableComponent,
    GenericGroupedDataSideNavComponent,

    PlatformTableComponent,
    PlatformTableXComponent,
    BaseChartDirective,
    MultiselectDropdown,
    MultiSelectSearchFilter,

    PlatformRouterLink, PlatformRouterLinkWithHref
  ],
  providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules }, // add as factory to your providers
    Adal5Service,
    { provide: Adal5HTTPService, useFactory: Adal5HTTPService.factory, deps: [HttpClient, Adal5Service] },
    ObjectDiffFinderService,
  ],
})
export class WebPlatformCoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WebPlatformCoreModule,
      providers: [
        { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules } // add as factory to your providers
      ],
    };
  }
}

